import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import { ReactElement } from 'react';
import { passwordRules } from '../../../constants/passwordRules';
import styleRules from './styles';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  setOpen(status: boolean): void;
}

const useStyles = makeStyles((theme) => createStyles(styleRules(theme)));

const ModalPasswordRules = ({ open, setOpen }: Props): ReactElement => {
  const { t } = useTranslation();

  const { body, button, dialogActions, myuserlist, title } = useStyles();

  const renderRules = (rules: string[]) => (
    <DialogContent>
      <ul>
        {rules.map((rule) => (
          <li key={rule} className={myuserlist}>
            <DialogContentText className={title} key={rule}>
              {t(rule)};
            </DialogContentText>
          </li>
        ))}
      </ul>
    </DialogContent>
  );

  return (
    <>
      <Dialog className={body} open={open} onClose={() => setOpen(false)}>
        {renderRules(passwordRules)}
        <DialogActions className={dialogActions}>
          <Button onClick={() => setOpen(false)} variant="contained" color="primary" autoFocus className={button}>
            {t('auth.got.it')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalPasswordRules;
